import { FiBarChart2, FiHelpCircle, FiMessageSquare, FiSettings, FiTrash2, FiUserPlus, FiUsers } from "react-icons/fi";
import { MdAirplanemodeActive, MdAirplanemodeInactive, MdOutlineAssignmentInd, MdOutlineDriveFileRenameOutline, MdOutlineInventory2, MdOutlinePublishedWithChanges, MdOutlineRemoveRedEye, MdSpeed, } from "react-icons/md";
import { TbArrowDownToArc, TbArrowUpToArc, TbCalendarMonth, TbCalendarUser, TbCancel, TbDeviceIpadPlus, TbEdit, TbUserShield } from "react-icons/tb";
import { AiOutlineClear, AiOutlineCreditCard, AiOutlineLineChart, AiOutlineShareAlt, AiOutlineStock, AiOutlineUser } from "react-icons/ai";
import { FaAngleDown, FaAngleLeft, FaAngleRight } from "react-icons/fa";
import {  HiOutlineHome } from "react-icons/hi";
import { GrDocumentConfig, GrDocumentText, GrDocumentUser, GrSettingsOption } from "react-icons/gr";
import { PiBagLight, PiCirclesThreePlus, PiDotsThreeOutlineVerticalFill, PiInvoice, PiMoneyLight, PiUsersThree } from "react-icons/pi";
import { BiCartAdd, BiCategoryAlt, BiCopy, BiMoneyWithdraw } from "react-icons/bi";
import { IoAddOutline, IoCalendarNumberOutline, IoFilterOutline, IoGitBranchOutline, IoHandLeftOutline, IoSearchOutline, IoVideocamOutline } from "react-icons/io5";
import { IoIosNotificationsOutline, IoMdAdd, IoMdClose } from "react-icons/io";
import { LiaSitemapSolid, LiaUserFriendsSolid, LiaUserInjuredSolid, LiaUsersSolid } from "react-icons/lia";
import { BsArrowDownUp, BsBank, BsChatDots, BsChatSquareDots } from "react-icons/bs";
import { CiCalendarDate, CiViewList } from "react-icons/ci";
import { HiOutlineDocumentChartBar } from "react-icons/hi2";
import { TfiGallery, TfiViewListAlt } from "react-icons/tfi";
import { LuAlarmClockOff, LuDownload, LuLayoutDashboard } from "react-icons/lu";
import { GoInfo, GoIssueReopened } from "react-icons/go";
import { CgProfile } from "react-icons/cg";
import { FaUserLarge } from "react-icons/fa6";

export const Icons = {
  HOME:<HiOutlineHome />,
  ADD:<IoMdAdd />,
  VIEW:<MdOutlineRemoveRedEye />,
  EDIT:<TbEdit />,
  DELETE:<FiTrash2 />,
  SHARE:<AiOutlineShareAlt />,
  DOWNLOAD:<LuDownload />,
  RENAME:<MdOutlineDriveFileRenameOutline /> ,
  RIGHTARROW: <FaAngleRight />,
  LEFTARROW: <FaAngleLeft />,
  DOTS:<PiDotsThreeOutlineVerticalFill />,
  COPY:<BiCopy />,
  VIDEO:<IoVideocamOutline />,
  ANNOUNCEMENT:<IoVideocamOutline />,
  CLOSE:<IoMdClose />,
  CANCEL: <TbCancel />,
  FILTER:<IoFilterOutline />,
  SHORTING:<BsArrowDownUp />,
  IMPORT:<TbArrowDownToArc />,
  EXPORT:<TbArrowUpToArc />,
  ASSIGN:<MdOutlineAssignmentInd />,
  DOCUMENT:<HiOutlineDocumentChartBar />,
  INFORMATION:<GoInfo />,
  DROPDOWN:<FaAngleDown /> ,
  SEARCH:<IoSearchOutline />,
  CLEAR:<AiOutlineClear />,
  EXPIRE:<LuAlarmClockOff />,
  ACTIVE:<MdAirplanemodeActive />,
  INACTIVE:<MdAirplanemodeInactive />,
  USER:<FaUserLarge />,
  PUBLISH:<MdOutlinePublishedWithChanges />,
  ONHOLD:<IoHandLeftOutline />,
  REOPEN:<GoIssueReopened />,


  SCHEDULE:<GoIssueReopened />,
  HOLD:<IoHandLeftOutline />,
  OFFER:<MdOutlinePublishedWithChanges />,
  HIRE:<MdOutlineAssignmentInd />,
  
};

export const SidebarIcons = {
  DASHBOARD: <LuLayoutDashboard />,
  PROJECTS: <TfiViewListAlt />,
  TEAM: <FiUsers />,
  CLIENTS: <AiOutlineUser />,
  USERS: <FiUserPlus />,
  PAYMENTS: <AiOutlineCreditCard />,
  REPORTS: <FiBarChart2 />,
  MESSAGES: <FiMessageSquare />,
  SETTINGS: <FiSettings />,
  ANALYTICS: <AiOutlineLineChart />,
  HELP: <FiHelpCircle />,
  HR:<PiCirclesThreePlus />,
  STAFFDIRECTORY: <LiaUserFriendsSolid />,
  STAFFATTENDANCE: <CiCalendarDate />,
  STAFFLEAVE: <TbCalendarUser />,
  SALARYSETUP: <GrDocumentConfig />,
  HOLIDAY: <TbCalendarMonth />,
  GENERATESALARY: <TbDeviceIpadPlus />,
  PAYROLLREPORT: <PiMoneyLight />,
  LEADS:<BsChatSquareDots />,
  ALLOWANCE: <PiMoneyLight />,
  CIBIL:<MdSpeed />,
  CUSTOMERS:<PiUsersThree />,
  LOAN:<BiMoneyWithdraw />,
  CHAT:<BsChatDots />,
  TASKLIST:<CiViewList />,
  INVENTORY:<MdOutlineInventory2 />,
  CONFIGRATION:<GrSettingsOption />,
  GALLERY:<TfiGallery />,
  DEPARTMENT:<LiaSitemapSolid />,
  DESIGNATION:<GrDocumentUser />,
  BRANCH:<IoGitBranchOutline />,
  BANK:<BsBank />,
  CALENDAR:<IoCalendarNumberOutline />,
  NOTIFICATION:<IoIosNotificationsOutline />,
  PROFILE:<CgProfile />,
  CATEGORIES:<BiCategoryAlt />,
  STOCK:<AiOutlineStock />,
  PURCHASEREQUEST: <BiCartAdd />,
  PURCHASEORDER: <GrDocumentText />,
  PURCHASEINVOICE: <PiInvoice />,
  VENDORS: <LiaUserInjuredSolid />,
  PERMISSSION: <TbUserShield />,
  JOBOPENING:<PiBagLight />,
  CANDIDATES:<LiaUsersSolid />
};